import heroDesktopImage from '../../images/shipplay/backgrounds/desktop/emerald-cruises-hero-background-20251106.jpg';
import heroMobileImage from '../../images/shipplay/backgrounds/mobile/emerald-cruises-hero-background-20251106.jpg';
import navLogo from '../../images/shipplay/logos/emerald-cruises-logo-20251022.svg';
import footerLogo from '../../images/shipplay/logos/Ship&Play_FullColor_DarkBG.svg';
import shipPlayLogo from '../../images/shipplay/logos/Ship&Play_FullColor_DarkBG.svg';

// 20250915 new images
import journeyImage from '../../images/shipplay/emerald_cruises/emerald-journey-20250918.jpg';
import ctaBackgroundImage from '../../images/shipplay/emerald_cruises/emerald-cta-background-20250918.jpg';
import stepIcon1 from '../../images/shipplay/cruise-step-icon-1.png';
import stepIcon2 from '../../images/shipplay/cruise-step-icon-2.png';
import stepIcon3 from '../../images/shipplay/cruise-step-icon-3.png';

const partnerConfig = {
  'name': 'Emerald Cruises',
  'path': 'emerald-cruises',
  'brand': 'shipplay',
  'template': 'modern', // This flags the component to use new structure
  'subdomain': null,
  'couponCode': '',
  'defaultCTAPath': '/pricing',
  'showNavExtraLinks': false,
  'logoClasses': 'w-60 sm:w-64 md:w-80 lg:w-auto max-w-80',
  'logoURL': '/emerald-cruises',
  'defaultMenuItems': [
    { 'name': 'Track', 'path': '/track' },
    { 'name': 'How it works', 'path': 'emerald-steps' },
    { 'name': 'Ship now', 'path': 'leading-tight' }
  ],
  'images': {
    'backgroundMobile': heroMobileImage,
    'backgroundDesktop': heroDesktopImage,
    'heroBackgroundPosition': '0% 100%',
    'navLogo': navLogo,
    'footerLogo': footerLogo,
    'shipPlayLogo': shipPlayLogo
  },
  'sections': [
    {
      'type': 'hero',
      'title': 'Smooth Sailing Starts Here',
      'subtitle': 'For luxurious travel, ship your luggage to and from your cruise with Ship&Play.',
      'backgroundImage': heroDesktopImage,
      'backgroundPosition': '0% 100%',
      'customClass': 'emerald-hero',
      'showQuickQuote': true
    },
    {
      'type': 'journey',
      'title': 'Enjoy the journey - send your bags with Ship&Play',
      'description': [
        'Your Emerald cruise will be relaxing. Getting there should be, too. That’s where Ship&Play comes in. ' +
        'Instead of lugging heavy suitcases, waiting in baggage lines, and worrying that a suitcase didn’t make ' +
        'the connecting flight, simply ship your bags with Ship&Play—the luggage shipping company trusted by ' +
        'travelers worldwide. Arrive hands-free and carefree knowing your bags will be waiting for you. ' +
        'Then, when your voyage ends, send them back just as easily—souvenirs and all.'
      ],
      'image': journeyImage,
      'imageAlt': 'Beautiful cruise destination',
      'features': [
        {
          'title': 'Have your bags picked up at your home',
          'description':  ' - or drop them off locally at our trusted carrier partner.'
        },
        {
          'title': 'Meet your bags where you want them',
          'description': ' - whether that\'s in your stateroom or at your hotel before setting sail.'
        },
        {
          'title': 'Enjoy access to our dedicated cruise concierge team',
          'description': ' - our specialists are ready to assist 7 days a week.'
        }
      ],
      'customClass': 'emerald-journey'
    },
    {
      'type': 'steps',
      'title': 'Three steps to stress-free travel',
      'subtitle': 'See how simple shipping can be.',
      'backgroundColor': 'bg-[#1C2938] color-white',
      'steps': [
        {
          'title': 'Book easily',
          'icon': stepIcon1,
          'description': 'Place your order online, by phone, or have your travel advisor arrange it for you.' 
        },
        {
          'title': 'Pack your bags',
          'icon': stepIcon2,
          'description': 'No need for boxes. Pack as you would for a flight, ' +
                        'attach the provided shipping labels, and relax.'
        },
        {
          'title': 'Meet Your bags on board',
          'icon': stepIcon3,
          'description': 'Skip baggage claim and all that airport hassle. ' +
                        'Your bags will be waiting for you when you arrive.'
        }
      ],
      'customClass': 'emerald-steps'
    },
    {
      'type': 'expectations',
      'title': 'What you can expect',
      'subtitle': 'with Ship&Play',
      'backgroundColor': 'bg-white',
      'expectations': [
         {
          'title': 'Shipping made easy',
          'description': 'You\'ll receive pre-printed labels, customs forms, if needed, ' + 
            '<br class="hidden md:block" />and detailed directions for smooth sailing.'
        },
        {
          'title': 'On-time guarantee',
          'description': 'Travel relaxed knowing your bags will be there, and track <br class="hidden md:block" />' + 
                          'their progress in real time from just about anywhere.'
        },
        {
          'title': 'A dedicated cruise concierge team',
          'description': 'Ship&Play provides assistance 7 days a week, and even ' +
            '<br class="hidden md:block" /> handles the tedious customs paperwork.'
        },
        {
          'title': 'Complimentary insurance',
          'description': 'Enjoy $500 of coverage at no cost to you, or explore ' +
            '<br class="hidden md:block" />additional options.'
        }
      ],
      'customClass': 'emerald-expectations'
    },
    {
      type: 'video',
      title: 'Watch <span>how it works</span>',
      description: 'See how easy it is to ship your bags to your cruise with Ship&Play. ' + 
                   'Enjoy the journey from start to finish.',
      buttonText: 'Watch on YouTube',
      videoUrl: 'https://www.youtube.com/watch?v=JjQgmsUugJs',
      backgroundColor: '#F5F5F5'
    },
    {
      'type': 'cta',
      'title': 'Goodbye baggage. Hello vacation.',
      'subtitle': 'Start your stress-free journey today',
      'buttonText': 'Get started',
      'buttonLink': '/pricing',
      'backgroundImage': ctaBackgroundImage,
      'backgroundPosition': 'center center',
      'customClass': 'emerald-cta'
    },
    {
      'type': 'contact',
      'title': 'Concierge team',
      'description': 'If you need help booking your cruise shipment, your plans have changed, ' +
        'or you have a question, a dedicated cruise concierge team is available for your convenience. ' +
        'Reach out by phone, text, email, or chat - whatever works best for you.',
      'backgroundColor': 'bg-gray-50',
      'contactInfo': {
        'phone': '(855) 566-2085',
        'email': 'emerald@shipplay.com',
        'hours': [
          'Mon - Fri: 8 AM - 8 PM EST',
          'Sat: 9 AM - 5 PM EST',
          'Sun: 9 AM - 6 PM EST'
        ]
      },
      'customClass': 'emerald-contact'
    }
  ],
  'footer': {
    'showTerms': true,
    'termsTitle': 'Any Questions?',
    'defaultTerms': 'Our dedicated customer support team is here for you every ' +
      'single day of the week. Should you have any questions or need additional ' +
      'information, please call or text us at (855) 566-2085.',
    'showNewsletter': true,
    'customClass': 'emerald-footer'
  },
  'footerLogoSize': 'w-[150px] lg:w-[150px]',
  'footerLogo': footerLogo,
  'supportPhoneNumber': '(855) 566-2085'
};

export default partnerConfig;